/** @jsxImportSource @emotion/react */
import { JSX } from 'react';
import { Variant } from '../../../typings/meta-call-restrictions';

export function getChannelNameText(channelNames: string[]): string {
  const validNames = channelNames.filter(Boolean);

  if (validNames.length === 0) {
    return 'your WABA';
  }

  if (validNames.length === 1) {
    return validNames[0];
  }

  if (validNames.length === 2) {
    return `${validNames[0]} and ${validNames[1]}`;
  }

  return `${validNames[0]} +${validNames.length - 1} Channels`;
}

export function getNotificationBody(variant: Variant, channelNames: string[]): JSX.Element {
  const channelNameText = getChannelNameText(channelNames);

  return variant === Variant.Warning ? (
    <>
      Multiple users have blocked or reported your calls. If this continues, Meta may temporarily restrict calling on{' '}
      <strong>{channelNameText}</strong> for 7 days.
    </>
  ) : (
    <>
      WhatsApp calling on <strong>{channelNameText}</strong> has been restricted by Meta for up to 7 days due to low
      pickup rates and users reporting or blocking your calls.
    </>
  );
}

export function getNotificationTitle(variant: Variant): string {
  return variant === Variant.Warning
    ? 'Your WhatsApp calls may be paused soon'
    : 'Your WhatsApp calls are paused by Meta';
}
